import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OperatorPriceChangeFilterEntity } from '../../domain/entities/OperatorPriceChangeFilterEntity'

export class OperatorPriceChangeFilterModel extends OperatorPriceChangeFilterEntity {
  constructor(dataDto: OperatorPriceChangeFilterEntity) {
    super()
    mapEntityProperties<OperatorPriceChangeFilterModel>(this, dataDto)
  }
}
